module.exports = __webpack_public_path__ + "img/icon_accessControl.9a375eba.png";